<template>
  <v-card flat color="transparent">
    <v-img      
      src="../../assets/caminhaov02.png"
      class="img-caminhao"
      contain
      :width="width"
    ></v-img>
    <slot />
  </v-card>
</template>

<script>
export default {
  props: {
    width: { type: Number },
  },
  methods: {
    isMobile() {
      return this.$mq == "sm";
    },
  },
};
</script>

<style>
.img-caminhao {
  z-index: 0;
}

@media only screen and (max-width: 750px) {
  .img-caminhao {
    display: none;
  }
}
</style>